import {environment} from '~env/environment';
import {OrderedMap} from 'immutable';
import {distinct} from '~utils/list-utils';
import {IconeVo} from '~model/vo/rota-vo';

export const zIndexStatusMonitoramento: { [key: string]: [number, number] } = {
  pendente: [0, 2000],
  removida: [1, 1000],
  chegando: [2, 5000],
  chegou: [3, 4000],
  realizando: [4, 6000],
  problema_realizar: [5, 9000],
  problema_sair: [6, 8000],
  realizada: [7, 3000],
  atraso: [8, 7000],
  nao_realizada: [9, 10000],
  integracao: [10, 7000],
  /** repetidos */
  cancelada: [1, 1000],
  adiada: [8, 7000],
  integracao_servico: [10, 7000],
  integracao_visita: [10, 7000],
  /** EXTRAS */
  cd: [50, 11000],
  veiculo: [70, 12000],
  evento: [90, 13000],
};

export const StatusMonitoramento = OrderedMap(zIndexStatusMonitoramento).keySeq().toArray();

export enum TipoEnum {
  C = 'C',
  EC = 'E+C',
  E = 'E',
  D = 'D'
}

export const TipoServico: { [key: number]: string } = {
  0: 'Coleta', 1: 'Entrega/Coleta', 2: 'Entrega', 3: 'Depósito',
};

export const TipoServicoIcon: { [key: number]: TipoEnum } = {
  0: TipoEnum.C, 1: TipoEnum.EC, 2: TipoEnum.E, 3: TipoEnum.D,
};

export const indexIcon = (tipos: string[]) => {
  tipos = tipos.filter(distinct);
  if (tipos.includes('EC') || tipos.includes('E+C') || tipos.length > 1) {
    return 1;
  }
  if (tipos.includes('D')) {
    return 3;
  }
  return tipos.includes('C') ? 0 : 2;
};

export const imageApi = `${environment.proxy.imageApi}/png`;
export const iconSize = 40;

export const urlIconStatus = (icon: IconeVo, color?: string, text?: string, sub?: string): string => {
  color = color ?? '';
  switch (icon.iconID) {
    // case zIndexStatusMonitoramento.veiculo[0]:
    //   return `${imageApi}/vehicle/base-${color.replace('#', '')}/${iconSize}`;
    case zIndexStatusMonitoramento.cd[0]:
      return `${imageApi}/monitoramento/base/${iconSize}/CD`;
    case zIndexStatusMonitoramento.evento[0]:
      return 'report_problem';
  }
  text = text ?? (icon.textID !== undefined ? TipoServicoIcon[icon.textID ?? 0] : undefined);
  const element = StatusMonitoramento[icon.iconID ?? 0];
  if (!element) {
    return '';
  }
  let url = `${imageApi}/monitoramento/${element}/${iconSize}`;
  if (text !== undefined) {
    url += `/${text}`;
    if (sub !== undefined) {
      url += `/${sub}`;
    }
  }
  return url;
};

export const pending = (status: string) => {
  return ['pendente'].includes(status.toLowerCase());
};

export const onClient = (status: string) => {
  return ['chegando', 'chegou', 'realizando']
    .includes(status.toLowerCase());
};

export const inProgress = (status: string) => {
  return ['chegou', 'realizando', 'problema_realizar', 'problema_sair', 'integracao_servico', 'integracao_visita', 'realizada', 'nao_realizada']
    .includes(status.toLowerCase());
};

export const finished = (status: string) => {
  return ['realizada', 'problema_realizar', 'problema_sair', 'nao_realizada', 'integracao_servico', 'integracao_visita']
    .includes(status.toLowerCase());
};

export const canceled = (status: string) => {
  return ['removida', 'cancelada','adiada']
    .includes(status.toLowerCase());
};

export const adiada = (status: string) => {
  return ['adiada']
    .includes(status.toLowerCase());
};

export const EventosVisiveis = ['ALERTA', 'PRIORIDADE', 'TEMPOATENDIMENTOEXCEDIDO', 'ENTROUEMAREADERISCO', 'ABASTECIMENTO', 'CAFEDAMANHA', 'PARADA', 'LANCHE', 'JANTAR', 'VELOCIDADE_EXCEDIDA', 'AGUACAO'];
export const IconEventos: { [key: string]: string } = {
  ALERTA: 'warning',
  PRIORIDADE: 'notification_important',
  TEMPOATENDIMENTOEXCEDIDO: 'warning_amber',
  VELOCIDADE_EXCEDIDA: 'warning',
  ENTROUEMAREADERISCO: 'warning_amber',

  INICIO_AGUACAO: 'water_drop',
  FIM_AGUACAO: 'water_drop',

  INICIO_ABASTECIMENTO: 'local_gas_station',
  FIM_ABASTECIMENTO: 'local_gas_station',

  INICIO_CAFEDAMANHA: 'local_dining',
  FIM_CAFEDAMANHA: 'local_dining',

  INICIOALMOCO: 'local_dining',
  FIMALMOCO: 'local_dining',

  INICIO_LANCHE: 'local_dining',
  FIM_LANCHE: 'local_dining',

  INICIO_JANTAR: 'local_dining',
  FIM_JANTAR: 'local_dining',

  INICIO_DESCANSO: 'hotel',
  FIM_DESCANSO: 'hotel',

  VEICULO: 'local_shipping',
  INCIDENTE: 'emergency_home',
};
// TODO Conferir 2020-12-08 (23...) Alertas mesma hora

